import React from 'react';
import {Control, Controller, RegisterOptions} from 'react-hook-form';
import TextField from '@mui/material/TextField';
import {TextFieldCounter} from "../TextFieldCounter"; // Supondo que você esteja usando MUI


interface SEControlledInputProps {
    control: Control;
    name: string;
    rules?: RegisterOptions;
    label: string;
    placeholder?: string;
    maxLength?: number;
    showMaxLength?: boolean;
    textarea?: boolean;
    [key: string]: any;
}
const SEControlledInput: React.FC<SEControlledInputProps> = ({
                                    control,
                                    name,
                                    rules,
                                    label,
                                    placeholder = '',
                                    textarea,
                                    showMaxLength,
                                    maxLength = 255,
                                    ...props
                                }) => {
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
                <>
                    <TextField
                        id={name}
                        label={label}
                        placeholder={placeholder}
                        fullWidth
                        value={value || ""}
                        onChange={onChange}
                        inputProps={{ maxLength }}
                        sx={textarea ? {
                            "& .MuiInputBase-root": {
                                height: "100%",
                            },
                        } : null}
                        {...props}
                    />
                    { showMaxLength ? <TextFieldCounter value={value} maxLength={maxLength} /> : null }
                    {error && <p style={{ color: 'red', marginTop: '8px' }}>{error.message}</p>}
                </>
            )}
        />
    );
};

export default SEControlledInput;